import { Component } from "react";
import "./App.css";
import posthog from "posthog-js";

import OrderTrackPage from "./Layouts/Pages/OrderTrackPage/OrderTrackPage";

class App extends Component {

    constructor(props) {
        super(props);
        this.moveChatWidget = this.moveChatWidget.bind(this);
    }

    moveChatWidget() {
        if (!document.getElementById("wa-chat-btn-root")) {
            window.requestAnimationFrame(this.moveChatWidget);
        } else {
            document.getElementById("wa-chat-btn-root").style.transform = "translateY(-50px)";
        }
    };

    componentDidMount() {
        posthog.init(process.env.React_APP_POSTHOG_KEY, {
            api_host: "https://app.posthog.com",
        });
        document.documentElement.style.setProperty(
            "--color-dark",
            process.env.REACT_APP_COLOR_DARK
        );
        document.documentElement.style.setProperty(
            "--color-lighest",
            process.env.REACT_APP_COLOR_LIGHEST
        );
        document.documentElement.style.setProperty(
            "--color-light",
            process.env.REACT_APP_COLOR_LIGHT
        );

        if (window.screen.width < 550) {
            if (document.getElementById("wa-chat-btn-root")) {
                document.getElementById("wa-chat-btn-root").style.transform =
                    "translateY(-50px)";
            }
        }
        this.moveChatWidget();
    };

    render() {
        return (
            <div className="App">
                <OrderTrackPage />
            </div>
        );
    }
}

export default App;
